import {
  getCurrentNgoProfile,
  ngoCreateProfile,
} from "appState/auth/authSlice";
import { TKIconSpinner } from "assets/images/svgs";
import { useFormik } from "formik";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import InputField from "shared/InputField";
import InputSelect from "shared/InputSelect";
import { nigerianBanks } from "utilities/data";
import { createProfile2ValidationSchema } from "validation/ngo/profile/createProfile2Schema";

const NGOAccount = ({ body }) => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state.auth);

  const formik = useFormik({
    initialValues: {
      bank_name: "",
      beneficiary: "",
      signatories: "",
      account_number: "",
    },
    validationSchema: createProfile2ValidationSchema,
    onSubmit: (values) => {
      const profileBody = {
        bank_name: values.bank_name,
        beneficiary: values.beneficiary,
        signatories: values.signatories,
        account_number: values.account_number,
      };
      dispatch(
        ngoCreateProfile({
          ...body,
          beneficiary: profileBody.beneficiary,
          bank_name: profileBody.bank_name,
          signatories: profileBody.signatories,
          account_number: profileBody.account_number,
        })
      ).then((data) => {
        const { payload } = data;
        if (payload?.status === 200) {
          dispatch(getCurrentNgoProfile()).then(() => {
            toast.success("NGO profile created successfully");
          });
        }
      });
    },
  });

  return (
    <div className="flex flex-col gap-y-4 items-center justify-center">
      <div className="w-4/5 flex flex-col gap-y-4">
        <div className="flex items-center mt-8 mb-4 justify-center">
          <p className="font-bold text-[18px]">Account Details</p>
        </div>
        <div className="flex items-start justify-start">
          <p className="text-[#7A7A7A] text-[14px]">
            Please provide your organizations bank details for monetary
            donations.
          </p>
        </div>
        <div className="flex flex-col items-start justify-center">
          <p className="font-medium text-[14px]">Note</p>
          <div>
            <ul className="list-disc text-[#7A7A7A] text-[14px]">
              <li>
                <p>
                  The account name must correspond with the name of the
                  organization.
                </p>
              </li>
              <li>
                <p>
                  Personal account details will not be accepted for the purpose
                  of receiving monetary donations.
                </p>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="w-4/5 mb-5 flex justify-start items-start">
        <form
          onSubmit={formik.handleSubmit}
          className="w-full flex flex-col gap-y-4"
        >
          <div className="flex flex-col gap-2">
            <label className="text-[14px] font-normal">
              Beneficiary of Account
            </label>
            <InputField
              className="border border-[#E6E6E6] rounded-md"
              type="text"
              name="beneficiary"
              id="beneficiary"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.beneficiary}
            />
            {formik.touched.beneficiary && formik.errors.beneficiary ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.beneficiary}
              </p>
            ) : null}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-[14px] font-normal">Bank Name</label>
            <InputSelect
              options={nigerianBanks}
              name="bank_name"
              optionsHolder="Select a bank"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.bank_name}
            />
            {formik.touched.bank_name && formik.errors.bank_name ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.bank_name}
              </p>
            ) : null}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-[14px] font-normal">Account Number</label>
            <InputField
              className="border border-[#E6E6E6] rounded-md"
              type="text"
              name="account_number"
              id="account_number"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.account_number}
            />
            {formik.touched.account_number && formik.errors.account_number ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.account_number}
              </p>
            ) : null}
          </div>
          <div className="flex flex-col gap-2">
            <label className="text-[14px] font-normal">
              Names of all authorized signatories to account
            </label>
            <textarea
              className="px-4 py-2 bg-white border border-[#E6E6E6] rounded-md placeholder:text-[14px]"
              rows="5"
              name="signatories"
              placeholder="List the signatories"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.signatories}
            />
            {formik.touched.signatories && formik.errors.signatories ? (
              <p className="text-red-500 text-xs mt-[8px] w-[300px] md:w-[424px]">
                {formik.errors.signatories}
              </p>
            ) : null}
          </div>
          <button
            // onClick={() => closeToggle(false)}
            type="submit"
            className="bg-[#213874] flex justify-center items-center text-white py-2 rounded-md"
          >
            {isLoading ? <TKIconSpinner /> : "Save"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NGOAccount;
